import { JSX } from "react";

import Grid from "@mui/material/Grid";

export default function LoginBanner(): JSX.Element {
	return (
		<Grid
			container
			alignItems="center"
			justifyContent="center"
			direction="column"
			sx={{ height: "100vh" }}>
			<Grid item>
				<img
					style={{
						width: "480px",
						paddingBottom: "80px"
					}}
					src="logo/logo-full.svg"
					alt="trajectx-logo"
				/>
			</Grid>

			<Grid item>
				<div
					style={{
						fontFamily:
							'"Baloo Da 2","Helvetica","Arial","sans-serif"',
						color: "white",
						lineHeight: "1.2"
					}}>
					<div
						style={{
							fontSize: "4rem",
							fontWeight: 700,
							paddingBottom: "30px"
						}}>
						<div style={{ color: "#20e0c9" }}>Revolutionizing</div>
						<div>Skill Development</div>
					</div>
					<div style={{ fontSize: "1.5rem", fontWeight: 400 }}>
						<div
							style={{
								background:
									"linear-gradient(130deg,#20e0c9,#0040ff 131.69%)",
								height: "3.5rem",
								top: "5px",
								width: "5px",
								float: "left"
							}}
						/>
						<div
							style={{
								float: "left",
								paddingLeft: "20px"
							}}>
							<div>
								Your <strong>All-in-One</strong> Evaluation
							</div>
							<div>and Guidance Platform</div>
						</div>
					</div>
				</div>
			</Grid>
		</Grid>
	);
}
